import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RoleGuard } from '@cv-invision/core';
import { ManageQueuesComponent } from './manage-queues.component';

const routes: Routes = [
    {
        path: 'manage-queues',
        component: ManageQueuesComponent,
        canActivate: [RoleGuard],
        data: {
            subComponentShow: false,
            module: 'intelligence',
        },
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class ManageQueuesRoutingModule {}
